import React from 'react';
import styled from 'styled-components';
import { Row, Column } from '@lux/components';
import { noop } from '@lux/helpers';

import Anchor from '../Anchor';
import Button from '../Button';
import Spacing from '../Spacing';

const StyledCheckoutArea = styled.div`
  margin-bottom: ${p => p.theme.spacing(5)};

  ${p => p.theme.media.lg`
    margin-bottom: ${p.theme.spacing(0)};
  `};
`;

const CheckoutArea = props => {
  const { onCheckout, onClearCart } = props;

  return (
    <StyledCheckoutArea>
      <Row center="sm">
        <Column sm={12}>
          <Spacing bottom={2}>
            <Button block onClick={() => onCheckout()}>
              Checkout
            </Button>
          </Spacing>
        </Column>
        <Column sm={12}>
          <Spacing bottom={2}>
            <Anchor>Save cart</Anchor>
          </Spacing>
        </Column>
        <Column sm={12}>
          <Anchor onClick={() => onClearCart()}>Clear cart</Anchor>
        </Column>
      </Row>
    </StyledCheckoutArea>
  );
};

CheckoutArea.defaultProps = {
  onCheckout: noop,
  onClearCart: noop
};

export default CheckoutArea;
